// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__PlEuy","load8":"loader_load8__Jr5NL"};